import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { invalidateOnSuccess, transformErrorResponse } from "src/store/helpers";
import { ApiResponse, BasicApiResponse } from "src/types";

import { sanitizeEmailConfigFromApi } from "../utils/emailConfigForm";

import { AdminBuilder } from "./tags";

const settings = (builder: AdminBuilder) => ({
    getEmailConfig: builder.query<API.EmailConfig, void>({
        providesTags: ["EmailConfig"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        transformResponse: (response: ApiResponse<API.EmailConfig>) => sanitizeEmailConfigFromApi(response.model),
        query: async () => {
            const base = await RouteService.getConfigRoute();
            return { url: `${base}email` };
        },
    }),

    updateEmailConfig: builder.mutation<BasicApiResponse, API.EmailConfig>({
        invalidatesTags: invalidateOnSuccess("EmailConfig"),
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async (config) => {
            const base = await RouteService.getConfigRoute();
            return { url: `${base}email`, method: "PUT", data: config };
        },
    }),

    sendTestEmail: builder.mutation<BasicApiResponse, void>({
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async () => {
            const base = await RouteService.getConfigRoute();
            return { url: `${base}email`, method: "POST" };
        },
    }),

    getCertificate: builder.query<API.Certificate, void>({
        providesTags: ["Certificate"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async () => {
            const base = await RouteService.getSettingsRoute();
            return { url: `${base}certificates/all` };
        },
    }),

    updateCertificate: builder.mutation<void, string>({
        invalidatesTags: invalidateOnSuccess("Certificate"),
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async (certificateString) => {
            const base = await RouteService.getSettingsRoute();
            return { url: `${base}certificates`, method: "PUT", data: { certificateString } };
        },
    }),
});

export default settings;
